import styles from "../../PricingTool.module.css";

interface SegOption { key: string; label: string; sub?: string }
interface Props { opts: SegOption[]; active: string; onSel: (k: string) => void; sm?: boolean }

export default function Seg({ opts, active, onSel, sm }: Props) {
  return (
    <div className={styles.seg}>
      {opts.map((o) => (
        <button
          key={o.key}
          className={`${styles.seg_btn} ${active === o.key ? styles.seg_btn_active : styles.seg_btn_inactive}`}
          style={{ padding: sm ? "5px 11px" : "7px 14px", fontSize: sm ? 12 : 13 }}
          onClick={() => onSel(o.key)}
        >
          <span>{o.label}</span>
          {o.sub && <span className={styles.seg_btn_sub}>{o.sub}</span>}
        </button>
      ))}
    </div>
  );
}
